import { addons } from '@storybook/addons';
import ambushTheme from './ambushTheme';

addons.setConfig({
  theme: ambushTheme,
});
